import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { DoctorService, token } from "../api";

// doctor profile
export const actionGetDetailDoctor = createAsyncThunk(
  "doctor/detail_doctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doGetDetailDoctor(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetSearchDateWorkingDoctor = createAsyncThunk(
  "doctor/search-dateWorking-doctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doGetSearchDateWorkingDoctor(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCreateInfo = createAsyncThunk(
  "doctor/create-info",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doCreateInfo(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionUpdateInfo = createAsyncThunk(
  "doctor/update-info",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doUpdateInfo(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetAllDoctor = createAsyncThunk(
  "doctor/get-all-doctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doGetAllDoctor(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// doctor working
export const actionGetDateWorkingDoctor = createAsyncThunk(
  "doctor/get-date-working-doctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doGetDateWorkingDoctor(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCreateDateWorking = createAsyncThunk(
  "doctor/create-date-working",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doCreateDateWorking(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionUpdateDateWorking = createAsyncThunk(
  "doctor/update-date-working",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doUpdateDateWorking(id, data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionDeleteDateWorking = createAsyncThunk(
  "doctor/delete-date-working",
  async (id, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doDeleteDateWorking(id);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// doctor price
export const actionGetExaminationPrice = createAsyncThunk(
  "doctor/get-examination-price",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doGetExaminationPrice(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionDeleteExaminationPrice = createAsyncThunk(
  "doctor/delete-examination-price",
  async (id, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doDeleteExaminationPrice(id);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCreateExaminationPrice = createAsyncThunk(
  "doctor/create-examination-price",
  async (data, { rejectWithValue }) => {
    try {
      // debugger;
      const res = await DoctorService.doCreateExaminationPrice(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionUpdateExaminationPrice = createAsyncThunk(
  "doctor/update-examination-price",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doUpdateExaminationPrice(id, data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCreateExaminationPriceChild = createAsyncThunk(
  "doctor/create-service-price",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doCreateExaminationPriceChild(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionUpdateExaminationPriceChild = createAsyncThunk(
  "doctor/update-service-price",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doUpdateExaminationPriceChild(id, data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionDeleteExaminationPriceChild = createAsyncThunk(
  "doctor/delete-service-price",
  async (id, { rejectWithValue }) => {
    try {
      const res = await DoctorService.doDeleteExaminationPriceChild(id);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const doctorSlice = createSlice({
  name: "doctor",
  initialState: {
    // doctor profile
    searchDateWorkingDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    detailDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    createInfo: {
      loading: false,
      data: null,
      error: "",
    },
    updateInfo: {
      loading: false,
      data: null,
      error: "",
    },
    getAllDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    // doctor working
    dateWorkingDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    updateDateWorking: {
      loading: false,
      data: null,
      error: "",
    },
    deleteDateWorking: {
      loading: false,
      data: null,
      error: "",
    },
    createDateWorking: {
      loading: false,
      data: null,
      error: "",
    },

    // doctor price
    examinationPrice: {
      loading: false,
      data: null,
      error: "",
    },
    createExaminationPrice: {
      loading: false,
      data: null,
      error: "",
    },
    updateExaminationPrice: {
      loading: false,
      data: null,
      error: "",
    },
    deleteExaminationPrice: {
      loading: false,
      data: null,
      error: "",
    },
    createExaminationPriceChild: {
      loading: false,
      data: null,
      error: "",
    },
    updateExaminationPriceChild: {
      loading: false,
      data: null,
      error: "",
    },
    deleteExaminationPriceChild: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // doctor profile
      // get all doctor
      .addCase(actionGetAllDoctor.pending, (state) => {
        state.getAllDoctor.loading = true;
      })
      .addCase(actionGetAllDoctor.fulfilled, (state, action) => {
        state.getAllDoctor.loading = false;
        state.getAllDoctor.data = action.payload;
      })
      .addCase(actionGetAllDoctor.rejected, (state, action) => {
        state.getAllDoctor.loading = false;
        state.getAllDoctor.data = action.payload;
        state.getAllDoctor.error =
          action.error.message || "Something went wrong";
      })
      // detail doctor
      .addCase(actionGetDetailDoctor.pending, (state) => {
        state.detailDoctor.loading = true;
      })
      .addCase(actionGetDetailDoctor.fulfilled, (state, action) => {
        state.detailDoctor.loading = false;
        state.detailDoctor.data = action.payload;
      })
      .addCase(actionGetDetailDoctor.rejected, (state, action) => {
        state.detailDoctor.loading = false;
        state.detailDoctor.data = action.payload;
        state.detailDoctor.error =
          action.error.message || "Something went wrong";
      })
      // detail doctor
      .addCase(actionGetSearchDateWorkingDoctor.pending, (state) => {
        state.searchDateWorkingDoctor.loading = true;
      })
      .addCase(actionGetSearchDateWorkingDoctor.fulfilled, (state, action) => {
        state.searchDateWorkingDoctor.loading = false;
        state.searchDateWorkingDoctor.data = action.payload;
      })
      .addCase(actionGetSearchDateWorkingDoctor.rejected, (state, action) => {
        state.searchDateWorkingDoctor.loading = false;
        state.searchDateWorkingDoctor.data = action.payload;
        state.searchDateWorkingDoctor.error =
          action.error.message || "Something went wrong";
      })
      // actionUpdateInfo
      .addCase(actionUpdateInfo.pending, (state) => {
        state.updateInfo.loading = true;
      })
      .addCase(actionUpdateInfo.fulfilled, (state, action) => {
        state.updateInfo.loading = false;
        state.updateInfo.data = action.payload;
      })
      .addCase(actionUpdateInfo.rejected, (state, action) => {
        state.updateInfo.loading = false;
        state.updateInfo.data = action.payload;
        state.updateInfo.error = action.error.message || "Something went wrong";
      })
      // action CreateInfo
      .addCase(actionCreateInfo.pending, (state) => {
        state.createInfo.loading = true;
      })
      .addCase(actionCreateInfo.fulfilled, (state, action) => {
        state.createInfo.loading = false;
        state.createInfo.data = action.payload;
      })
      .addCase(actionCreateInfo.rejected, (state, action) => {
        state.createInfo.loading = false;
        state.createInfo.data = action.payload;
        state.createInfo.error = action.error.message || "Something went wrong";
      })
      // doctor working
      // get-date-working-doctor
      .addCase(actionGetDateWorkingDoctor.pending, (state) => {
        state.dateWorkingDoctor.loading = true;
      })
      .addCase(actionGetDateWorkingDoctor.fulfilled, (state, action) => {
        state.dateWorkingDoctor.loading = false;
        state.dateWorkingDoctor.data = action.payload;
      })
      .addCase(actionGetDateWorkingDoctor.rejected, (state, action) => {
        state.dateWorkingDoctor.loading = false;
        state.dateWorkingDoctor.data = action.payload;
        state.dateWorkingDoctor.error =
          action.error.message || "Something went wrong";
      })
      // create-date-working
      .addCase(actionCreateDateWorking.pending, (state) => {
        state.createDateWorking.loading = true;
      })
      .addCase(actionCreateDateWorking.fulfilled, (state, action) => {
        state.createDateWorking.loading = false;
        state.createDateWorking.data = action.payload;
      })
      .addCase(actionCreateDateWorking.rejected, (state, action) => {
        state.createDateWorking.loading = false;
        state.createDateWorking.data = action.payload;
        state.createDateWorking.error =
          action.error.message || "Something went wrong";
      })
      // update-date-working
      .addCase(actionUpdateDateWorking.pending, (state) => {
        state.updateDateWorking.loading = true;
      })
      .addCase(actionUpdateDateWorking.fulfilled, (state, action) => {
        state.updateDateWorking.loading = false;
        state.updateDateWorking.data = action.payload;
      })
      .addCase(actionUpdateDateWorking.rejected, (state, action) => {
        state.updateDateWorking.loading = false;
        state.updateDateWorking.data = action.payload;
        state.updateDateWorking.error =
          action.error.message || "Something went wrong";
      })
      // delete-date-working
      .addCase(actionDeleteDateWorking.pending, (state) => {
        state.deleteDateWorking.loading = true;
      })
      .addCase(actionDeleteDateWorking.fulfilled, (state, action) => {
        state.deleteDateWorking.loading = false;
        state.deleteDateWorking.data = action.payload;
      })
      .addCase(actionDeleteDateWorking.rejected, (state, action) => {
        state.deleteDateWorking.loading = false;
        state.deleteDateWorking.data = action.payload;
        state.deleteDateWorking.error =
          action.error.message || "Something went wrong";
      })

      // update-service-price
      // doctor price
      .addCase(actionUpdateExaminationPriceChild.pending, (state) => {
        state.updateExaminationPriceChild.loading = true;
      })
      .addCase(actionUpdateExaminationPriceChild.fulfilled, (state, action) => {
        state.updateExaminationPriceChild.loading = false;
        state.updateExaminationPriceChild.data = action.payload;
      })
      .addCase(actionUpdateExaminationPriceChild.rejected, (state, action) => {
        state.updateExaminationPriceChild.loading = false;
        state.updateExaminationPriceChild.data = action.payload;
        state.updateExaminationPriceChild.error =
          action.error.message || "Something went wrong";
      })
      // examinationPrice
      .addCase(actionGetExaminationPrice.pending, (state) => {
        state.examinationPrice.loading = true;
      })
      .addCase(actionGetExaminationPrice.fulfilled, (state, action) => {
        state.examinationPrice.loading = false;
        state.examinationPrice.data = action.payload;
      })
      .addCase(actionGetExaminationPrice.rejected, (state, action) => {
        state.examinationPrice.loading = false;
        state.examinationPrice.data = action.payload;
        state.examinationPrice.error =
          action.error.message || "Something went wrong";
      })
      // create
      .addCase(actionCreateExaminationPriceChild.pending, (state) => {
        state.createExaminationPriceChild.loading = true;
      })
      .addCase(actionCreateExaminationPriceChild.fulfilled, (state, action) => {
        state.createExaminationPriceChild.loading = false;
        state.createExaminationPriceChild.data = action.payload;
      })
      .addCase(actionCreateExaminationPriceChild.rejected, (state, action) => {
        state.createExaminationPriceChild.loading = false;
        state.createExaminationPriceChild.data = action.payload;
        state.createExaminationPriceChild.error =
          action.error.message || "Something went wrong";
      })
      // delete
      .addCase(actionDeleteExaminationPriceChild.pending, (state) => {
        state.deleteExaminationPriceChild.loading = true;
      })
      .addCase(actionDeleteExaminationPriceChild.fulfilled, (state, action) => {
        state.deleteExaminationPriceChild.loading = false;
        state.deleteExaminationPriceChild.data = action.payload;
      })
      .addCase(actionDeleteExaminationPriceChild.rejected, (state, action) => {
        state.deleteExaminationPriceChild.loading = false;
        state.deleteExaminationPriceChild.data = action.payload;
        state.deleteExaminationPriceChild.error =
          action.error.message || "Something went wrong";
      })

      // create
      .addCase(actionCreateExaminationPrice.pending, (state) => {
        state.createExaminationPrice.loading = true;
      })
      .addCase(actionCreateExaminationPrice.fulfilled, (state, action) => {
        state.createExaminationPrice.loading = false;
        state.createExaminationPrice.data = action.payload;
      })
      .addCase(actionCreateExaminationPrice.rejected, (state, action) => {
        state.createExaminationPrice.loading = false;
        state.createExaminationPrice.data = action.payload;
        state.createExaminationPrice.error =
          action.error.message || "Something went wrong";
      })
      // delete
      .addCase(actionDeleteExaminationPrice.pending, (state) => {
        state.deleteExaminationPrice.loading = true;
      })
      .addCase(actionDeleteExaminationPrice.fulfilled, (state, action) => {
        state.deleteExaminationPrice.loading = false;
        state.deleteExaminationPrice.data = action.payload;
      })
      .addCase(actionDeleteExaminationPrice.rejected, (state, action) => {
        state.deleteExaminationPrice.loading = false;
        state.deleteExaminationPrice.data = action.payload;
        state.deleteExaminationPrice.error =
          action.error.message || "Something went wrong";
      })

      // update
      .addCase(actionUpdateExaminationPrice.pending, (state) => {
        state.updateExaminationPrice.loading = true;
      })
      .addCase(actionUpdateExaminationPrice.fulfilled, (state, action) => {
        state.updateExaminationPrice.loading = false;
        state.updateExaminationPrice.data = action.payload;
      })
      .addCase(actionUpdateExaminationPrice.rejected, (state, action) => {
        state.updateExaminationPrice.loading = false;
        state.updateExaminationPrice.data = action.payload;
        state.updateExaminationPrice.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default doctorSlice.reducer;
export const { actions, reducer } = doctorSlice;
